/* eslint-disable prefer-arrow/prefer-arrow-functions */
// eslint-disable-next-line max-len
// Inspired from https://github.com/mantinedev/mantine/blob/master/src/mantine-hooks/src/use-click-outside/use-click-outside.ts
import { useEffect, useRef } from 'react';
/**
 * Custom hook to detect clicks outside a specified element.
 *
 * @param callback - The callback function to be called when a click outside the element is detected.
 * @param events - Array of event types to listen for.
 *
 * @returns A mutable ref object representing the target element.
 */
const useClickOutside = (callback, events = ['mousedown', 'touchstart']) => {
    const targetRef = useRef(null);
    useEffect(() => {
        // Event listener function to check if the click is outside the target element
        const listener = (event) => {
            if (targetRef.current && !targetRef.current.contains(event.target)) {
                callback(event);
            }
        };
        // Add event listeners for each specified event type
        events.forEach(eventType => document.addEventListener(eventType, listener));
        // Cleanup function to remove event listeners
        return () => {
            events.forEach(eventType => document.removeEventListener(eventType, listener));
        };
    }, [targetRef, callback, events]);
    return targetRef;
};
export default useClickOutside;
